module.exports = __webpack_public_path__ + "static/img/home_main_entrance.683da939.png";